module.exports = __webpack_public_path__ + "img/under-maintenance.143e2444.svg";